(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["promo-code"] && !Shopify.designMode) return;
  try {
    class PromoCountdownTimer extends HTMLElement {
  connectedCallback() {
    const target = document.getElementById('product-countdown');
    if (!target) return;

    const endDateAttr = this.getAttribute('end-date');
    const currentDateAttr = this.getAttribute('current-date-and-time');
    if (!endDateAttr) return;

    const end = new Date(endDateAttr);
    const _second = 1000;
    const _minute = _second * 60;
    const _hour = _minute * 60;
    const _day = _hour * 24;

    const update = () => {
      const now = currentDateAttr ? new Date(currentDateAttr) : new Date();
      const distance = end - now;

      if (distance < 0) {
        clearInterval(this._timer);
        target.innerHTML = '<div class="single"><strong>EXPIRED!</strong></div>';
        return;
      }

      const days = Math.floor(distance / _day);
      const hours = Math.floor((distance % _day) / _hour);
      const minutes = Math.floor((distance % _hour) / _minute);
      const seconds = Math.floor((distance % _minute) / _second);

      target.innerHTML = `
        <div class="single"><strong>${days}</strong><p>days</p></div>
        <div class="single"><strong>:</strong></div>
        <div class="single"><strong>${hours}</strong><p>hours</p></div>
        <div class="single"><strong>:</strong></div>
        <div class="single"><strong>${minutes}</strong><p>mins</p></div>
        <div class="single"><strong>:</strong></div>
        <div class="single"><strong>${seconds}</strong><p>secs</p></div>
      `;

      // Update currentDateAttr for next tick
      const newNow = new Date(now.getTime() + 1000);
      currentDateAttr && (this.setAttribute('current-date-and-time', newNow.toISOString()));
    };

    update(); // initial render
    this._timer = setInterval(update, 1000);
  }

  disconnectedCallback() {
    clearInterval(this._timer);
  }
}

customElements.define('promo-countdown-timer', PromoCountdownTimer);
  } catch(e) { console.error(e); }
})();

})();
